module.exports = __webpack_public_path__ + "img/13_of_Hearts.svg.69340846.png";